import { PdfTemplateModule } from '@vpfa/rest-api/valuation';

export const pdfTemplateModules: PdfTemplateModule[] = [
  PdfTemplateModule.Valuation,
  PdfTemplateModule.Stock,
  PdfTemplateModule.Quote,
  PdfTemplateModule.StockOffers,
];
